import React from 'react';
import { useSetAtom } from 'jotai';
import { RESET } from 'jotai/utils';
import { drawerAtom } from '../atoms/drawer.atom';
import { usePendingAnnotations } from '../hooks/use-pending-annotations';
import { PendingAnnotationHeader } from './pending-annotation-header';
import { PendingAnnotationPanel } from './pending-annotation-panel';
const PendingAnnotationTitle = () => {
  const pendingAnnotations = usePendingAnnotations();
  return <PendingAnnotationHeader heading="Pending Annotations" showTag={pendingAnnotations.length > 0} count={pendingAnnotations.length} countText="remaining" />;
};
const PENDING_ANNOTATION_DRAWER_PROPS = {
  title: () => <PendingAnnotationTitle />,
  description: 'Complete questionnaires for pending annotations',
  component: () => <PendingAnnotationPanel />,
  isOpen: true,
  styles: {
    contentContainerStyles: {
      overflow: 'hidden'
    }
  }
};
export const usePendingAnnotationDrawer = () => {
  const setDrawer = useSetAtom(drawerAtom);
  const openPendingItemDrawer = () => {
    const onClose = () => setDrawer(RESET);
    setDrawer({
      ...PENDING_ANNOTATION_DRAWER_PROPS,
      onClose
    });
  };
  const closePendingItemDrawer = (onCloseCallback?: () => void) => {
    if (onCloseCallback) {
      onCloseCallback();
    }
  };
  return {
    openPendingItemDrawer,
    closePendingItemDrawer
  };
};